module.exports = __webpack_public_path__ + "img/pay.434a7434.png";